import styled from 'styled-components';

// CONSTANTS
import { PORCELAIN, WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Wrapper = styled.div`
  > div {
    width: 100%;

    &:not(:first-child) {
      &:nth-child(even) {
        background-color: ${WHITE};

        &#channels {
          .channel-card {
            .channel-card__container {
              background-color: ${PORCELAIN};
            }
          }
        }
      }

      &:nth-child(odd) {
        background-color: ${PORCELAIN};

        &#channels {
          .channel-card {
            .channel-card__container {
              background-color: ${WHITE};
            }
          }
        }
      }
    }
  }

  .similar-content-section {
    padding: 85px 0;

    ${breakpoints.up('md')} {
      padding: 110px 0;
    }
  }
`;

export const ProgressWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  position: relative;
  z-index: 1102;
`;

export const Container = styled.div`
  position: relative;
  padding-top: 32px;
  padding-bottom: 32px;

  ${breakpoints.down('md')} {
    padding-top: 85px;
    padding-bottom: 85px;

    h3 {
      font-size: 3rem;
      line-height: 3rem;
    }
  }

  ${breakpoints.down('xs')} {
    padding-top: 60px;
    padding-bottom: 60px;
  }

  .popupbox {
    z-index: 1220;

    &-wrapper {
      ${breakpoints.down('xs')} {
        max-width: 96%;
      }
    }

    &-titleBar {
      border-bottom: none;
      padding: 0 37px 0 24px;
    }

    &-content {
      padding: 5px;

      img {
        display: block;
        max-width: 100%;
      }
    }

    &-btn--close {
      right: 5px;
      top: 50%;
      margin-top: -6px;
    }
  }

  .app {
    &__collection {
      &:not(:first-of-type) {
        padding-top: 20px;
      }
      &:not(:last-of-type) {
        padding-bottom: 20px;
      }
    }
  }

  &.other-apps-container {
    &--has-most-pop {
      padding-top: 0;
      padding-bottom: 32px;
    }
  }
`;

export const StyledIframe = styled.iframe`
  width: 100%;
  border: none;
  display: block;
  height: 460px;
  @media (max-width: 800px) {
    height: 560px;
  }
  @media (max-width: 650px) {
    height: 660px;
  }
  @media (max-width: 550px) {
    height: 720px;
  }
  @media (max-width: 450px) {
    height: 750px;
  }
  @media (max-width: 375px) {
    height: 800px;
  }
`;

export default Wrapper;
